import React, { FC, FormEvent, useState } from 'react'
import { CustomLayer, LineStyle } from 'models/custom-layer'
import { Stack } from 'components/Stack'
import { Flex } from 'components/Flex'
import { ColorPicker } from 'components/ColorPicker'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { buildSimpleOptions, buildSimpleOption } from 'utils/selectOption'
import { Select } from 'components/Select'
import styles from '../../CustomLayerStylesDialog.module.scss'

const STROKE_WIDTHS = [1, 2, 3, 4, 5]
const STROKE_WIDTH_OPTIONS = buildSimpleOptions(STROKE_WIDTHS)

type CustomLayerLineProps = {
  customLayer: CustomLayer
  onSubmit: (style: LineStyle) => void
  status: string
}

export const CustomLayerLine: FC<CustomLayerLineProps> = ({
  customLayer,
  onSubmit,
  status = 'idle',
}) => {
  const { t } = useTranslation()
  const [style, setStyle] = useState(customLayer.viz as LineStyle)

  const onFormSubmit = (event: FormEvent) => {
    event.preventDefault()
    onSubmit(style)
  }

  return (
    <form onSubmit={onFormSubmit}>
      <Stack space="medium">
        <Flex align="center">
          <Text component="span" weight="strong" className={styles.label}>
            {t('layer_style_dialog.form.color')}
          </Text>
          <ColorPicker
            value={style.paint['line-color']}
            onChange={(color) =>
              setStyle({
                ...style,
                paint: { ...style.paint, 'line-color': color },
              })
            }
          />
        </Flex>
        <Flex align="center">
          <Text component="span" weight="strong" className={styles.label}>
            {t('layer_style_dialog.form.stroke_width')}
          </Text>
          <Select
            options={STROKE_WIDTH_OPTIONS}
            value={buildSimpleOption(style.paint['line-width'])}
            className={styles.select}
            onChange={(option) =>
              setStyle({
                ...style,
                paint: { ...style.paint, 'line-width': parseInt(option!.value! as string) },
              })
            }
          />
        </Flex>

        <Button type="submit" full loading={status === 'loading'}>
          {t('layer_style_dialog.cta')}
        </Button>
      </Stack>
    </form>
  )
}
